import { ERROR_STARTDATE_FORMAT, ERROR_ENDDATE_FORMAT, ERROR_PROPOSAL_DATE_INVALID, ERROR_STARTDATE_EMPTY } from "../../../../utils/messages";
import { REGEX_DATE_SAVE, MAX_DB_DATE, MIN_DB_DATE, DATE_FORMAT } from "../../../../utils/constants";
import moment from 'moment';

function validateDates(payload) {

    let prompt = [];
    let isStartDateValid = moment(payload.startDate, DATE_FORMAT).isValid();
    let isEndDateValid = moment(payload.endDate, DATE_FORMAT).isValid();
    let startDate = isStartDateValid ? moment(payload.startDate).format(DATE_FORMAT) : payload.startDate.toString();
    let endDate = isEndDateValid ? moment(payload.endDate).format(DATE_FORMAT) : payload.endDate.toString();

    if (!startDate.match(REGEX_DATE_SAVE)) {
        prompt.push(ERROR_STARTDATE_FORMAT);
        isStartDateValid = false;
    }

    if (!endDate.match(REGEX_DATE_SAVE)) {
        prompt.push(ERROR_ENDDATE_FORMAT);
        isEndDateValid = false;
    }

    if (isStartDateValid && isEndDateValid) {
        if (moment(startDate) > moment(endDate)) {
            prompt.push(ERROR_PROPOSAL_DATE_INVALID);
        }

        if(moment(endDate) < moment(MAX_DB_DATE) && moment(startDate) <= moment(MIN_DB_DATE)){
            prompt.push(ERROR_STARTDATE_EMPTY);
        }
    }

    return prompt;
}

export {
    validateDates
};